<template>
  <v-select
    v-model="locale"
    :items="locales"
    hide-details
    dense
    :height="28"
    style="width: 136px"
    class="mt-0"
  >
    <template v-slot:prepend>
      <v-icon>{{ icon }}</v-icon>
    </template>
  </v-select>
</template>

<script>
import { mdiWeb } from "@mdi/js";
import { locales } from "@/i18n";
export default {
  data() {
    return { icon: mdiWeb };
  },
  created() {
    this.locales = locales;
  },
  computed: {
    locale: {
      get() {
        return this.$i18n.locale;
      },
      set(value) {
        this.$i18n.locale = value;
        this.$vuetify.lang.current = value;
        this.$store.dispatch("updateLocale", value);
        localStorage.setItem("locale", value);
      }
    }
  }
};
</script>

<style scoped>
>>> .v-select__selections input {
  height: 0;
  padding: 0 !important;
}
</style>
